<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const isVisible = ref(false)

const checkScroll = () => {
  // Show button when scrolled down 300px
  isVisible.value = window.scrollY > 300
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

onMounted(() => {
  window.addEventListener('scroll', checkScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', checkScroll)
})
</script>

<template>
  <button 
    v-show="isVisible" 
    @click="scrollToTop"
    class="fixed bottom-[154px] right-6 z-40 w-[50px] h-[50px] bg-white/90 dark:bg-[#111827]/90 backdrop-blur-md border border-gray-200/60 dark:border-gray-700/60 rounded-full flex items-center justify-center text-emerald-600 dark:text-emerald-400 shadow-[0_4px_20px_rgba(0,0,0,0.08)] dark:shadow-[0_4px_20px_rgba(0,0,0,0.4)] hover:bg-emerald-50 dark:hover:bg-gray-800 transition-all duration-300 transform hover:-translate-y-0.5 hover:scale-105 hover:shadow-[0_8px_30px_rgba(0,0,0,0.12)]"
    aria-label="Back to top"
  >
    <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
    </svg>
  </button>
</template>

